<template>
  <div :class="{ 'container z-grid  v-page-section-container-padding': size === 'normal', '2xl:container mx-auto': size === 'wide' }">
    <div :class="{ 'z-grid__cols': size === 'normal' }">
      <div class="overflow-hidden shadow-md" :class="{ 'w-full': size === 'wide', 'rounded-3xl': size === 'normal' }">
        <MoleculePicture :image="size === 'wide' ? imageLarge : image" class="w-full h-full" />
        <h6 v-if="subtitle" class="bg-white text-xs sm:text-base py-3 px-4 sm:py-4 md:px-12 leading-tight" :class="{ 'rounded-br-3xl rounded-bl-3xl': size === 'normal' }">
          {{ subtitle }}
        </h6>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  image: { type: Object as PropType<Record<string, any>>, required: true },
  imageLarge: { type: Object as PropType<Record<string, any>>, required: true },
  size: { type: String, required: false, default: 'normal', validator: (value: string) => ['normal', 'wide'].includes(value) },
  subtitle: { type: String, required: false, default: '' },
})
</script>
